module.exports = __webpack_public_path__ + "img/22.a9718c7.png";